"use client";
import { Box, Flex } from "@chakra-ui/react";
import Image from "next/image";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";

const HeadComp = ({ Bg_Image, heading }) => {
  const HeadingVariant = useHeadingVariant();

  return (
    <Box
      as="header"
      position="relative"
      borderRadius="18px"
      overflow="hidden"
      minH="400px"
    >
      <Image
        src={Bg_Image}
        alt="Hero background"
        fill
        style={{ objectFit: "cover" }}
        priority
        sizes="100vw"
      />

      <Flex
        direction="column"
        gap="3rem"
        justifyContent={{ base: "center", md: "flex-start" }}
        color="white"
        height="100%"
        py={{ base: "3rem", md: "8rem" }}
        px={{ base: "1.5rem", md: "6rem" }}
        position="relative"
        zIndex="1"
      >
        <Heading
          variant={HeadingVariant}
          width={{ base: "100%", md: "70%" }}
          as="h1"
          fontSize={{ base: "2xl", md: "4xl" }}
        >
          🚀 {heading}
        </Heading>
      </Flex>
    </Box>
  );
};

export default HeadComp;
